/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M16.86 3.017c.45-.09.99.18 1.08.72l.45 2.067v.09c0 .09-.09.18-.18.18H7.05c-.09 0-.18-.09-.18-.18s.09-.18.18-.18l9.81-2.697ZM17.76 16.954c-1.53 0-2.88-1.259-2.88-2.877 0-1.619 1.26-2.878 2.88-2.878h1.71c.09 0 .18-.09.18-.18V9.132c0-1.079-.81-1.888-1.89-1.888H4.89c-1.08 0-1.89.81-1.89 1.888v9.98C3 20.102 3.81 21 4.89 21h12.87c1.08 0 1.89-.9 1.89-1.888v-1.888c0-.09-.09-.18-.18-.18h-1.71v-.09Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.01 12.368h-2.25c-.9 0-1.71.81-1.71 1.709s.72 1.708 1.71 1.708h2.25c.54-.09.99-.54.99-1.169v-1.169c0-.45-.36-.989-.99-1.079Z"
})), "0 0 24 24", "Wallet");